module.exports = __webpack_public_path__ + "static/media/Arrow_Left_Orange.ca0e984f.svg";